import { useTranslation } from "react-i18next";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import styles from "./PrivacyPolicy.module.scss";

const PrivacyPolicy = () => {
  const { t } = useTranslation("translation");

  return (
    <div className={styles.privacy}>
      <TitleUpdater title={t("privacy_policy")} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h3>{t("privacy_content.title")}</h3>
          </div>
          <div>
            <div className={styles.introduction}>
              <h2>{t("privacy_content.introduction.title")}</h2>
              <p>{t("privacy_content.introduction.content")}</p>
            </div>

            <div className={styles.introduction}>
              <h2>{t("privacy_content.terms.title")}</h2>
              <p>{t("privacy_content.terms.personal_data")}</p>
              <p>{t("privacy_content.terms.data_processing")}</p>
              <p>{t("privacy_content.terms.cookies")}</p>
              <p>{t("privacy_content.terms.anonymization")}</p>
            </div>

            <div className={styles.introduction}>
              {" "}
              <h2>{t("privacy_content.principles.title")}</h2>
              <p>{t("privacy_content.principles.description")}</p>
              <ul>
                <li>{t("privacy_content.principles.lawfulness")}</li>
                <li>{t("privacy_content.principles.minimization")}</li>
                <li>{t("privacy_content.principles.accuracy")}</li>
                <li>{t("privacy_content.principles.storage_limit")}</li>
                <li>{t("privacy_content.principles.security")}</li>
              </ul>
            </div>

            <div className={styles.introduction}>
              <h2>{t("privacy_content.data_categories.title")}</h2>
              <p>{t("privacy_content.data_categories.description")}</p>
              <ul>
                <li>{t("privacy_content.data_categories.identification")}</li>
                <li>{t("privacy_content.data_categories.contact")}</li>
                <li>{t("privacy_content.data_categories.financial")}</li>
                <li>{t("privacy_content.data_categories.technical")}</li>
                <li>{t("privacy_content.data_categories.geolocation")}</li>
                <li>{t("privacy_content.data_categories.purchase_history")}</li>
                <li>{t("privacy_content.data_categories.communication")}</li>
              </ul>
            </div>

            <div className={styles.introduction}>
              {" "}
              <h2>{t("privacy_content.purposes.title")}</h2>
              <p>{t("privacy_content.purposes.description")}</p>
              <ul>
                <li>{t("privacy_content.purposes.order_fulfillment")}</li>
                <li>{t("privacy_content.purposes.customer_support")}</li>
                <li>{t("privacy_content.purposes.financial_settlements")}</li>
                <li>{t("privacy_content.purposes.marketing")}</li>
                <li>{t("privacy_content.purposes.service_improvement")}</li>
                <li>{t("privacy_content.purposes.legal_obligations")}</li>
              </ul>
            </div>

            <div className={styles.introduction}>
              {" "}
              <h2>{t("privacy_content.legal_bases.title")}</h2>
              <ul>
                <li>{t("privacy_content.legal_bases.consent")}</li>
                <li>{t("privacy_content.legal_bases.contract")}</li>
                <li>{t("privacy_content.legal_bases.legal_obligation")}</li>
                <li>{t("privacy_content.legal_bases.legitimate_interests")}</li>
              </ul>
            </div>

            <div className={styles.introduction}>
              <h2>{t("privacy_content.retention_periods.title")}</h2>
              <ul>
                <li>{t("privacy_content.retention_periods.transaction")}</li>
                <li>{t("privacy_content.retention_periods.account")}</li>
                <li>{t("privacy_content.retention_periods.support")}</li>
              </ul>
              <p>{t("privacy_content.retention_periods.note")}</p>
            </div>

            <div className={styles.introduction}>
              <h2>{t("privacy_content.technical_measures.title")}</h2>
              <ul>
                <li>{t("privacy_content.technical_measures.ssl")}</li>
                <li>{t("privacy_content.technical_measures.encryption")}</li>
                <li>{t("privacy_content.technical_measures.vulnerability")}</li>
                <li>{t("privacy_content.technical_measures.logging")}</li>
                <li>
                  {t("privacy_content.technical_measures.access_control")}
                </li>
              </ul>
            </div>

            <div className={styles.introduction}>
              <h2>{t("privacy_content.administrative_measures.title")}</h2>
              <ul>
                <li>{t("privacy_content.administrative_measures.access")}</li>
                <li>
                  {t("privacy_content.administrative_measures.role_based")}
                </li>
                <li>{t("privacy_content.administrative_measures.training")}</li>
                <li>{t("privacy_content.administrative_measures.audits")}</li>
              </ul>
            </div>

            <div className={styles.introduction}>
              <h2>{t("privacy_content.physical_protection.title")}</h2>
              <ul>
                <li>{t("privacy_content.physical_protection.servers")}</li>
                <li>
                  {t("privacy_content.physical_protection.access_control")}
                </li>
                <li>{t("privacy_content.physical_protection.surveillance")}</li>
                <li>
                  {t("privacy_content.physical_protection.infrastructure")}
                </li>
                <li>
                  {t("privacy_content.physical_protection.server_access")}
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.introduction}>
            <h2>{t("privacy_content.payment_data.title")}</h2>
            <p>{t("privacy_content.payment_data.content")}</p>

            <h2>{t("privacy_content.cookies.title")}</h2>
            <p>{t("privacy_content.cookies.content")}</p>

            <h2>{t("privacy_content.analytics.title")}</h2>
            <p>{t("privacy_content.analytics.content")}</p>

            <h2>{t("privacy_content.personalized_offers.title")}</h2>
            <p>{t("privacy_content.personalized_offers.content")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
